"use strict";

const generateTOC = (article) => {
	const tocList = article.querySelector(".toc__list");
	const content = article.querySelector(".content");
	const headings = content.querySelectorAll("h1, h2");

	let chapCount = 0,
		headCount = 0;

	headings.forEach((heading, i) => {
		const tocItem = document.createElement("li");
		const link = document.createElement("a");

		if (heading.tagName === "H1") {
			heading.setAttribute("id", `chap-${chapCount + 1}`);
			tocItem.classList.add("chapter");
			link.setAttribute("href", `#chap-${chapCount + 1}`);
			link.textContent = heading.textContent;

			chapCount += 1;
			headCount = 0;
		}

		if (heading.tagName === "H2") {
			tocItem.classList.add("heading");

			if (heading.textContent === "Overview") {
				heading.setAttribute("id", "overview");
				link.setAttribute("href", "#overview");
				link.textContent = heading.textContent;
			} else {
				heading.setAttribute("id", `head-${chapCount}.${headCount + 1}`);
				tocItem.classList.add("child");
				link.setAttribute("href", `#head-${chapCount}.${headCount + 1}`);
				link.textContent = heading.textContent;

				headCount += 1;
			}
		}

		tocItem.appendChild(link);
		tocList.appendChild(tocItem);
	});
	/* chapters.forEach((chapter, i) => {
		if (!h.classList.contains("title")) {
			h.setAttribute("id", `heading-${i + 1}`);

			const tocItem = document.createElement("li");
			tocItem.classList.add("heading");
			tocItem.setAttribute("id", `heading-${i + 1}`);

			const link = document.createElement("a");
			link.setAttribute("href", `#${h.id}`);
			link.innerHTML = h.textContent;
			tocItem.appendChild(link);
			tocList.appendChild(tocItem);
		}

		const tocChildren = Array.from(tocList.children);

		tocChildren.forEach((li, i) => {
			if (
				i !== 0 &&
				li.classList.contains("heading") &&
				(tocChildren[i - 1].classList.contains("chapter") ||
					tocChildren[i - 1].classList.contains("child"))
			)
				li.classList.add("child");
		});
	}); */
};

export default generateTOC;
